import PropTypes from 'prop-types';
import { Button, Stack, CircularProgress } from '@mui/material';

export const LoadingButton = (props) => {
  const {
    title = '',
    loading = false,
    disabled = false,
    toggleClick = () => {},
    style = {},
    variant = 'outlined',
  } = props;

  return (
    <Button
      type="submit"
      fullWidth
      variant={variant}
      disabled={loading || disabled}
      onClick={toggleClick}
      sx={style}
    >
      <Stack
        direction="row"
        alignItems="center"
        spacing={2}
      >
        {loading && (
          <CircularProgress
            size={20}
            thickness={4}
            color="grey"
            disableShrink
          />
        )}
        <span>{title}</span>
      </Stack>
    </Button>
  );
};

LoadingButton.propTypes = {
  title: PropTypes.string,
  loading: PropTypes.bool,
  disabled: PropTypes.bool,
  toggleClick: PropTypes.func,
  style: PropTypes.object,
  variant: PropTypes.string,
};
